import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/ui/Button';

export function Login() {
  const { loginUrl, googleConfigured, devBypassEnabled, devLogin } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-light px-4 dark:bg-surface-dark">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-panel dark:border-slate-800 dark:bg-slate-900"
      >
        <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-pulse-600">
          <span className="relative flex h-3 w-3 items-center justify-center">
            <span className="absolute inline-flex h-3 w-3 animate-pulse-ring rounded-full bg-pulse-300" />
            <span className="relative h-3 w-3 rounded-full bg-white" />
          </span>
        </div>
        <h1 className="text-xl font-bold text-slate-900 dark:text-white">Health Academy Pulse</h1>
        <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400">
          Sign in with your Health Academy Google Workspace account to view live operational data.
        </p>

        {googleConfigured && (
          <a
            href={loginUrl}
            className="mt-6 flex w-full items-center justify-center gap-3 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z" />
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.9 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
              <path fill="#4CAF50" d="M24 44c5.5 0 10.4-1.9 14.3-5.1l-6.6-5.6C29.6 35 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.6 5.1C9.6 39.6 16.3 44 24 44z" />
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.7l6.6 5.6C41.9 36 44 30.5 44 24c0-1.3-.1-2.7-.4-3.5z" />
            </svg>
            Continue with Google
          </a>
        )}

        {devBypassEnabled && (
          <div className="mt-6">
            {!googleConfigured && (
              <div className="mb-4 rounded-lg border border-dashed border-slate-200 p-3 text-left text-xs text-slate-400 dark:border-slate-700">
                Google OAuth isn&apos;t configured yet, so this local build is running in demo mode.
              </div>
            )}
            <Button variant="secondary" className="w-full" onClick={() => devLogin()}>
              <Sparkles size={15} />
              Continue as Demo User
            </Button>
          </div>
        )}

        <p className="mt-5 text-xs text-slate-400">Access is restricted to authorized Health Academy staff.</p>
      </motion.div>
    </div>
  );
}
